module.exports = __webpack_public_path__ + "officialStatic/img/businessSBg.6a5157c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/businessSBg.jpg
// module id = bjvn
// module chunks = 0